export default "__VITE_ASSET__Bx$UCm7V__"